import { render } from "./UserAssignments.vue?vue&type=template&id=8bebf986&scoped=true"
import script from "./UserAssignments.vue?vue&type=script&lang=js"
export * from "./UserAssignments.vue?vue&type=script&lang=js"

import "./UserAssignments.vue?vue&type=style&index=0&id=8bebf986&scoped=true&lang=scss"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bebf986"]])

export default __exports__